import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=f98c7760&"
import script from "./back-button.vue?vue&type=script&lang=js&"
export * from "./back-button.vue?vue&type=script&lang=js&"
import style0 from "./back-button.vue?vue&type=style&index=0&id=f98c7760&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports